import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Switch from 'material-ui/Switch';
import { FormControlLabel } from 'material-ui/Form';
import SelectHierarchicalMenuDialog from './common/SelectHierarchicalMenuDialog';

const styles = () => ({
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '8px 16px',
    borderBottom: '1px solid #D8DBDF',
    background: '#FFFFFF',
  },
  toggleLabel: {
    fontSize: '14px',
    color: '#333',
  },
});

class SelectIndustryCategoryDialog extends React.Component {
  constructor(props) {
    super(props);
    // ダイアログが開いた時点の値を記録
    this.initialIndustrySearchMode = props.industrySearchMode;
  }

  handleToggle = () => {
    const { industrySearchMode, onSearchModeChange } = this.props;
    const newMode = industrySearchMode === 'primary_only' ? 'all' : 'primary_only';
    onSearchModeChange(newMode);
  };

  render() {
    const {
      classes,
      isOpen,
      toggleDialog,
      set,
      save,
      hierarchicalMenu,
      industrySearchMode,
    } = this.props;

    const isPrimaryOnly = industrySearchMode === 'primary_only';
    const hasSearchModeChanged = industrySearchMode !== this.initialIndustrySearchMode;

    const headerContent = (
      <div className={classes.toggleContainer}>
        <FormControlLabel
          control={
            <Switch
              checked={isPrimaryOnly}
              onChange={this.handleToggle}
              color="primary"
            />
          }
          label={<span className={classes.toggleLabel}>メイン業種のみで検索</span>}
        />
      </div>
    );

    return (
      <SelectHierarchicalMenuDialog
        isOpen={isOpen}
        toggleDialog={toggleDialog}
        set={set}
        save={save}
        title="業界を選択"
        hierarchicalMenu={hierarchicalMenu}
        colCount={3}
        headerContent={headerContent}
        hasExternalChanges={hasSearchModeChanged}
      />
    );
  }
}

SelectIndustryCategoryDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  set: PropTypes.object.isRequired,
  hierarchicalMenu: PropTypes.array.isRequired,
  industrySearchMode: PropTypes.string,
  onSearchModeChange: PropTypes.func,
};

SelectIndustryCategoryDialog.defaultProps = {
  industrySearchMode: 'all',
  onSearchModeChange: () => {},
};

export default withStyles(styles)(SelectIndustryCategoryDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectHierarchicalMenuDialog/SelectIndustryCategoryDialog.jsx